import { render, staticRenderFns } from "./EmployeeBadgesListView.vue?vue&type=template&id=55145a38&scoped=true"
import script from "./EmployeeBadgesListView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeBadgesListView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeBadgesListView.vue?vue&type=style&index=0&id=55145a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55145a38",
  null
  
)

export default component.exports